import { useContext, useEffect, useState } from "react";

import CustomDateInput from "../../../helperComponents/CustomDateInput";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import CustomToggle from "../../../helperComponents/CustomToggle";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const options = [
  { value: "MALE", label: "Mr" },
  { value: "FEMALE", label: "Mme" },
];

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export default function AskLeadership({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();

  const [founder, setFounder] = useState("");
  const [leader, setLeader] = useState("");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      if (loggedInUser.founderName) setFounder(loggedInUser.founderName);
      if (loggedInUser.leaderName) setLeader(loggedInUser.leaderName);
    }
  }, []);

  return (
    <OnboardingBoilerplate
      asEditPage={asEditPage}
      editPageTitle="Leadership"
      skipID={"leadershipDetailsOnboardingSkipped"}
      title={"Leadership"}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        <MaterialInput
          label={"Founder"}
          value={founder}
          onChange={extractEventValue(setFounder)}
        />
        <MaterialInput
          label={loggedInUser.accountType == "NGO" ? "Care Taker" : "CEO"}
          value={leader}
          onChange={extractEventValue(setLeader)}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    if (!founder) return window.popupAlert("Founder name missing");
    if (!leader) return window.popupAlert("Leader name missing");

    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { founderName: founder, leaderName: leader },
      });
      setLoading(false);
      let newLoggedInUser = {
        ...loggedInUser,
        founderName: founder,
        leaderName: leader,
      };
      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
